var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMobilityPlanner(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n\t\t\t.planner-a,.planner-d{fill:none;}\n\t\t"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-683 -310)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "planner-a",
    fill: "none",
    stroke: "#fff",
    transform: "translate(683 310)"
  }, /*#__PURE__*/React.createElement("rect", {
    stroke: "none",
    className: "c",
    width: 16,
    height: 16,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#fff",
    className: "planner-d",
    fill: "none",
    x: 0.5,
    y: 0.5,
    width: 15,
    height: 15,
    rx: 0.5
  })), /*#__PURE__*/React.createElement("rect", {
    fill: "#fff",
    className: "b",
    width: 8,
    height: 3,
    transform: "translate(685 321)"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#fff",
    className: "b",
    width: 11,
    height: 3,
    transform: "translate(685 317)"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#fff",
    className: "b",
    width: 4,
    height: 3,
    transform: "translate(685 312)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobilityPlanner);
export default __webpack_public_path__ + "static/media/MobilityPlanner.ea8cdd2556ab4a641173598b8b94cf62.svg";
export { ForwardRef as ReactComponent };